export default (admin = [], action) => {
    switch (action.type) {
        case 'FETCH_ADMIN':
            return action.payload;
        default:
            return admin;
    }
}